import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 2
export const listName = 'bem.historicoProcessos.list'
export const listStorage = tableColumnsCache(listName, [
    {label: 'Numero', name: 'numero', active: true, sortable: false, ordering: 1},
    {label: 'Início', name: 'inicio', active: true, sortable: false, ordering: 2},
    {label: 'Fim', name: 'fim', active: true, sortable: false, ordering: 3},
    {label: 'Situação', name: 'motivo', active: true, sortable: false, ordering: 4},
], listVersion)
